import Stage from "@frog/source/models/Stage.js"

export default {
    "enemy-only": {
        "canTarget": function({performerKey, stage, position}) {
            const performer = stage.units[performerKey]
            const target = Stage.findUnitByPosition(stage, position)
            if(target == undefined) return false
            return target.affiliation != performer.affiliation
        }
    },
    "ally-only": {
        "canTarget": function({performerKey, stage, position}) {
            const performer = stage.units[performerKey]
            const target = Stage.findUnitByPosition(stage, position)
            if(target == undefined) return false
            return target.affiliation == performer.affiliation
        }
    },
    "enemy-or-empty": {
        "canTarget": function({performerKey, stage, position}) {
            const performer = stage.units[performerKey]
            const target = Stage.findUnitByPosition(stage, position)
            if(target == undefined) return true
            return target.affiliation != performer.affiliation
        }
    },
    "ally-or-empty": {
        "canTarget": function({performerKey, stage, position}) {
            const performer = stage.units[performerKey]
            const target = Stage.findUnitByPosition(stage, position)
            if(target == undefined) return true
            return target.affiliation == performer.affiliation
        }
    },
    "only": {
        "canTarget": function({performerKey, stage, position}) {
            const performer = stage.units[performerKey]
            const target = Stage.findUnitByPosition(stage, position)
            if(target == undefined) return false
            return true
        }
    },
    "all": {
        "canTarget": function({performerKey, stage, position}) {
            const target = Stage.findUnitByPosition(stage, position)
            return true
        }
    },
}
